import renderHTML from 'react-render-html'

export function getMessage(key, text='') {
    const messages = {
        loginRequired: `To preview you need to be logged in, please login below:`,
        dialogShow: `Don't show this again`,
        emptyField: `Cannot be empty`,
        error: `There was an error.`,
        formEmailInvalid: `Invalid email address`,
        formEmailVerify: `Please verify your email address.`,
        formPasswordInvalid: `Password must contain at least 6 characters.`,
        formPasswordWeak: `The password is too weak.`,
        loginFail: `Your email or password was incorrect.`,
        loginFailIssue: `Login has failed, please make sure your password is at least 6 characters.`,
    }
    return renderHTML(messages[key])
}
